import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalComponent } from '../../shared/components/modals/modal/modal.component';
import { forkJoin } from "rxjs";
import { EducationalProgramClient, Project, ProjectClient, SectionClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';


@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent implements OnInit {

  modalRef: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private educationProgram: EducationalProgramClient,
    private sectionService: SectionClient,
    private projectClient: ProjectClient,
    private fileService: FileService,
  ) { }

  openModal() {
    this.modalRef = this.modalService.show(ModalComponent);
  }
  EP = [];
  sections = [];
  projects: Project[] = [];
  isLoading = true;
  ngOnInit(): void {
    forkJoin({
      sections: this.sectionService.getAll(),
      educationalPrograms: this.educationProgram.getAll(),
      projects: this.projectClient.getAll(),
    }).subscribe(({ educationalPrograms, projects, sections }) => {
      this.sections = sections;
      this.EP = educationalPrograms;
      this.projects = projects;
      this.isLoading = false;
    })
  }

  test(i: number) {
    var percent = i % 2;
    return percent < 1;
  }

  getColor(i) {
    if (i % 5 == 0) return " li1";
    if (i % 5 == 1) return "li2";
    if (i % 5 == 2) return "li3";
    if (i % 5 == 3) return " li4";
    if (i % 5 == 4) return "li5";
  }

  getImage(id: string) {
    if (id) {
      return this.fileService.getDownloadUrl(id);

    } else {
      return "/assets/user.png"
    }
  }
}
